import React from 'react';
import TickIcon from '../../atoms/icons/tick-icon';
import './micro-payment.m.css';

const PaymentSuccess = () => (
  <div data-testid="payment-success" id="payment-success" styleName="story-subscribe-wrap">
    <div styleName="story-subscribe">
      <div styleName="success-message">
        <h3 styleName="subscribe-headline">Thank You !</h3>
        <div styleName="success-message-summary">
          <TickIcon width={40} height={40} />
          <p styleName="subscribe-summary">
            Your payment was successful. Now you can continue reading the article.
          </p>
        </div>
        <span styleName="paywall-footer">This notification will be closed in 3 seconds…</span>
      </div>
    </div>
  </div>
);

export default PaymentSuccess;
